const UPSCALE_MODEL = 'upscale';
const VIRTUAL_STAGING_MODEL = 'virtual-staging';
const REMOVE_OBJECTS_MODEL = 'remove-objects';

export { UPSCALE_MODEL, VIRTUAL_STAGING_MODEL, REMOVE_OBJECTS_MODEL };
